export const glassboxErrorEvent = (error) => {
  function dispatchGbxErrorEvent() {
    document.dispatchEvent(
      new CustomEvent("GBXErrorReport", {
        detail: {
          GBX_Error: `${Dell.Metrics.sc.applicationname} = ${error}`, // pass dell.metrics.sc.applicationame=Error Message
        },
        bubbles: true,
      })
    );
  }

  if (typeof _detector !== undefined) {
    //Checks if Glassbox is already loaded and dispatch the event
    dispatchGbxErrorEvent();
  } // if Glassbox is not loaded, listen to GBXDetectorLoaded event and then dispatch the event
  else {
    window.addEventListener("GBXDetectorLoaded", function () {
      dispatchGbxErrorEvent();
    });
  }
};

export const glassboxSuccessEvent = (info) => {
  function dispatchGbxErrorEvent() {
    document.dispatchEvent(
      new CustomEvent("GBXErrorReport", {
        detail: {
          GBX_Info: `${Dell.Metrics.sc.applicationname} = ${info}`,
        },
        bubbles: true,
      })
    );
  }

  if (typeof _detector !== undefined) {
    dispatchGbxErrorEvent();
  } else {
    window.addEventListener("GBXDetectorLoaded", function () {
      dispatchGbxErrorEvent();
    });
  }
};

export const glassboxPopUpEvent = (state) => {
  function dispatchGbxPopUpEvent() {
    document.dispatchEvent(
      new CustomEvent("GBXPopUpReport", {
        detail: {
          State: `${state}`,
          ApplicationName: `${Dell.Metrics.sc.applicationname}_AddressModal`,
        },
        bubbles: true,
      })
    );
  }

  if (typeof _detector !== undefined) {
    dispatchGbxPopUpEvent();
  } else {
    window.addEventListener("GBXDetectorLoaded", function () {
      dispatchGbxPopUpEvent();
    });
  }
};
